module.exports = __webpack_public_path__ + "static/media/add-circle-icon.ca8dd37a.svg";